import { render, staticRenderFns } from "./RestaurantNotWorkingModal.vue?vue&type=template&id=66fa985b&scoped=true&"
import script from "./RestaurantNotWorkingModal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./RestaurantNotWorkingModal.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./RestaurantNotWorkingModal.vue?vue&type=style&index=0&id=66fa985b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fa985b",
  null
  
)

export default component.exports